const InlineInputField: React.FC<{
  value: string | number | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  type?: 'text' | 'number';
  required?: boolean;
  starDistance?: number;
}> = ({ value, onChange, placeholder, type = 'text', required = false, starDistance }) => {
  const hasValue = value !== '' && value !== undefined && value !== null;

  return (
    <div className="relative w-full">
      <input
        type={type}
        value={value ?? ''}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full p-2 px-3 rounded-lg border-[#4A082D] text-[#4A082D] bg-[#4A082D33] placeholder-[#621C43] focus:outline-none"
      />
      {required && !hasValue && (
        <span
          className={`absolute left-[calc(1rem+1ch*${
            starDistance || placeholder.length
          })] top-2 text-red-500 pointer-events-none ml-1`}
        >
          *
        </span>
      )}
    </div>
  );
};

export default InlineInputField;
